module.exports = __webpack_public_path__ + "static/media/tally_logo.2d9f4830.jpeg";